export default class HashService {
	async createHash() {
		throw new Error('Not implemented in the UI');
	}
}
